import { theme } from '@theme';
import { useMediaQuery } from '@mui/material';

type Breakpoint = 'mobile' | 'tablet' | 'desktop';

const useCheckBreakpoint = (breakpoint: Breakpoint) => {
  const { breakpoints } = theme;

  const breakpointDown = useMediaQuery(breakpoints.down(breakpoint));
  const breakpointUp = useMediaQuery(breakpoints.up(breakpoint));

  return { breakpointDown, breakpointUp };
};

export default useCheckBreakpoint;
